import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M27.195 2.745c-.32-1.08-1.26-1.931-2.454-2.22C22.576 0 13.897 0 13.897 0S5.217 0 3.053.525C1.86.814.92 1.665.6 2.745.02 4.705.02 8.791.02 8.791s0 4.087.58 6.045c.319 1.081 1.26 1.897 2.453 2.186 2.165.524 10.844.524 10.844.524s8.68 0 10.844-.524c1.194-.29 2.135-1.105 2.454-2.186.58-1.958.58-6.045.58-6.045s0-4.087-.58-6.046m-16.136 9.756v-7.42l7.254 3.71z"
    }, null, -1)
  ])))
}
export default { render: render }